import { render, staticRenderFns } from "./PropertyAddress.vue?vue&type=template&id=1c4e347a&scoped=true"
import script from "./PropertyAddress.vue?vue&type=script&lang=js"
export * from "./PropertyAddress.vue?vue&type=script&lang=js"
import style0 from "./PropertyAddress.vue?vue&type=style&index=0&id=1c4e347a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4e347a",
  null
  
)

export default component.exports